import {
  IReportSalesPlan,
  IReportBalance,
  IReportProfitAndLossPlan,
  IReportCashFlowPlan,
  IReportResultsOfFinancialAnalysis,
} from '@app/monitoring/interfaces';
import { createActionGroup, emptyProps } from '@ngrx/store';

import { IOption } from '@shared';

export interface IReportTableParams {
  projectId: number;
  scenarioId: number;
  page: number;
  period: string;
}

const monitoringActions = createActionGroup({
  source: 'Monitoring',
  events: {
    'Load Monitoring Projects': emptyProps(),
    'Load Monitoring Projects Success': (payload: IOption<number>[]) => ({ payload }),
    'Load Monitoring Projects Failure': (payload: unknown) => ({ payload }),
    //
    'Load Monitoring Project Scenarios': (payload: { projectId: number }) => ({ payload }),
    'Load Monitoring Project Scenarios Success': (payload: IOption<number>[]) => ({ payload }),
    'Load Monitoring Project Scenarios Failure': (payload: unknown) => ({ payload }),
    //
    'Set Current Monitoring Project': (payload: number) => ({ payload }),
    'Set Current Monitoring Scenario': (payload: number) => ({ payload }),
    'Set Current Monitoring Mode': emptyProps(),
    'Set Current Monitoring Report Type': (payload: string) => ({ payload }),
    'Set Report Data': emptyProps(),
    //
    'Get Report Sales Plan': (payload: IReportTableParams) => ({ payload }),
    'Get Report Sales Plan Success': (payload: IReportSalesPlan) => ({ payload }),
    'Get Report Sales Plan Failure': (payload: unknown) => ({ payload }),
    //
    'Get Report Balance': (payload: IReportTableParams) => ({ payload }),
    'Get Report Balance Success': (payload: IReportBalance) => ({ payload }),
    'Get Report Balance Failure': (payload: unknown) => ({ payload }),
    //
    'Get Report Profit And Lost Plan': (payload: IReportTableParams) => ({ payload }),
    'Get Report Profit And Lost Plan Success': (payload: IReportProfitAndLossPlan) => ({ payload }),
    'Get Report Profit And Lost Plan Failure': (payload: unknown) => ({ payload }),
    // getReportCashFlowPlan
    'Get Report Cash Flow Plan': (payload: IReportTableParams) => ({ payload }),
    'Get Report Cash Flow Plan Success': (payload: IReportCashFlowPlan) => ({ payload }),
    'Get Report Cash Flow Plan Failure': (payload: unknown) => ({ payload }),
    //
    'Get Report Results Of Financial Analysis': (payload: IReportTableParams) => ({ payload }),
    'Get Report Results Of Financial Analysis Success': (payload: IReportResultsOfFinancialAnalysis) => ({ payload }),
    'Get Report Results Of Financial Analysis Failure': (payload: unknown) => ({ payload }),
  },
});

export const {
  loadMonitoringProjects,
  loadMonitoringProjectsSuccess,
  loadMonitoringProjectsFailure,
  loadMonitoringProjectScenarios,
  loadMonitoringProjectScenariosSuccess,
  loadMonitoringProjectScenariosFailure,
  setCurrentMonitoringProject,
  setCurrentMonitoringScenario,
  setCurrentMonitoringMode,
  setCurrentMonitoringReportType,
  getReportSalesPlan,
  getReportSalesPlanSuccess,
  getReportSalesPlanFailure,
  getReportBalance,
  getReportBalanceSuccess,
  getReportBalanceFailure,
  getReportProfitAndLostPlan,
  getReportProfitAndLostPlanSuccess,
  getReportProfitAndLostPlanFailure,
  getReportCashFlowPlan,
  getReportCashFlowPlanSuccess,
  getReportCashFlowPlanFailure,
  getReportResultsOfFinancialAnalysis,
  getReportResultsOfFinancialAnalysisSuccess,
  getReportResultsOfFinancialAnalysisFailure,
} = monitoringActions;
